<template>
  <div class="revt-page" v-cloak>
    <header-nav :current="current"></header-nav>
    <!-- 阶段量表开始提示 -->
    <template v-if="[0,3].indexOf(step) > -1 && !showStagePage">
      <div class="exam-content">
        <div class="exam-tip-container">
          <!-- <div class="exam-title">{{ examType == 1 ? '理解量表' : '表达量表' }}</div> -->
          <div class="exam-label exam-label-container">
            <img src="../assets/img/pyrotechnics-big.png" alt="">
            <div class="exam-top-container">
              <img src="../assets/img/pyrotechnics-small.png" alt="">
              <div>施测前提醒</div>
            </div>
          </div>
          <div class="content-border" :class="question.exam_type == 2 ? 'content-border-express' : ''">
            <ul class="exam-tips">
              <template v-if="step == 0">
                <li v-for="(tip, index) in stepContent[step]" :key="index" v-html="'提醒'+(index + 1)+'：'+tip"></li>
              </template>
              <template v-if="step == 3">
                <li v-for="(tip, index) in stepContent[step - 2]" :key="index" v-html="'提醒'+(index + 1)+'：'+tip"></li>
              </template>
            </ul>
            <div class="exam-voice" @click="voiceVolume" v-if="step == 0">
              <div>音量</div>
              <div>测试</div>
            </div>
            <div class="express-url-container" v-if="showJoinCard">
              <div class="express-url-str" @click="copyUserUrl">
                <div class="express-url">{{ userClient }}</div>
                <div class="express-copy">点击复制受试连接</div>
              </div>
              <div class="express-qrcode">
                <qr-code :value="userClient" :size="codeSize"></qr-code>
                <div class="scan-tip">移动设备扫码施测</div>
              </div>
            </div>
          </div>
        </div>
        <div class="exam-next-btn" @click="showQuestion">
          <span class="span-btn">下一步</span>
        </div>
      </div>
    </template>
    <template v-if="showStagePage">
      <div class="exam-stage">
        <div class="state-shadow"></div>
        <div class="exam-stage-cate">
          <div class="exam-stage-cate-title">
            {{ examType == 1 ? '理解量表' : '表达量表' }}
          </div>
          <div class="exam-question-type">
            {{ questionType == 1 ? '练习题' : '正式题' }}
          </div>
          <div class="exam-next-btn">
            <span class="span-btn" @click="showQuestion">
              {{questionType === 1 ? '下一步' : '开始作答'}}
            </span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="[1,4].indexOf(step) > -1 && !showStagePage">
      <div class="exam-content">
        <div class="exam-tip-container steer-page-tip">
          <div class="exam-label exam-label-container">
            <img src="../assets/img/pyrotechnics-big.png" alt="">
            <div class="exam-top-container">
              <img src="../assets/img/pyrotechnics-small.png" alt="">
              <div>指导语</div>
            </div>
          </div>
          <div class="content-border min-height-content">
            <ul class="exam-tips">
              <li style="text-indent:0;margin-left: 0;">
                <template v-if="question.exam_type === 1">
                  接下来你会看到一些图片，我会问你一些问题，请你把正确的答案指出来，请你尽量试试看！
                </template>
                <template v-if="question.exam_type === 2">
                  接下来你会看到一些图片，我会问你一些问题，请你把答案说出来，请你尽量试试看！
                </template>
              </li>
            </ul>
          </div>
        </div>
        <div class="exam-begin-btn" @click="showQuestion">
          开始作答
        </div>
      </div>
    </template>
    <template>
      <div class="question-container user-client-container" ref="questionContianerRef" v-show="[2,5,6].indexOf(step) > -1 && !showStagePage">
        <div class="title title-margin-bottom" ref="questionTitleRef" style="align-items: center">
          <template v-if="loadedCanvas || loadedExpress">
            <template v-if="question.question_type === 1">
              <div class="title-label">
                练习{{
                  question.number
                }}{{ question.number_count > 1 ? '-' + question.sort : '' }}
                <template v-if="question.quiz_items === 1">
                  （命名）
                </template>
                <template v-if="question.quiz_items === 2">
                  （归类）
                </template>
                <template v-if="question.quiz_items === 3">
                  （定义）
                </template>
                <template v-if="question.quiz_items === 4">
                  （推理）
                </template>
              </div>
              {{question.subject.length > 0 ? question.title : ''}}
            </template>
            <template v-else>
            <span class="title-label" style="color: #000">
              第&nbsp;{{ question.number }}{{ question.number_count > 1 ? '-' + question.sort : '' }}&nbsp;题
            </span>&nbsp;
              {{question.subject && question.subject.length > 0 ? question.title : '' }}
            </template>
          </template>
          <template v-else>
            <div class="title-skeleton"></div>
          </template>
        </div>
        <div class="understand" v-show="answerWay == 1">
          <div class="revt-canvas" style="padding: 16px 0">
            <div class="show-loading" v-show="!loadedCanvas"
                 :style="{width:loadingWidth+'px',height:loadingHeight+'px'}">
              <div class="loader">
                <div class="pacman">
                  <div class="mouth"></div>
                </div>
                <div class="dot"></div>
              </div>
            </div>
            <canvas ref="canvas" v-show="loadedCanvas" style="border:0px solid #ccc; cursor: pointer;"></canvas>
          </div>
        </div>
        <template v-if="question.action_guide && question.action_guide.length > 0">
          <span class="action-guide" ref="actionGuideRef">（{{question.action_guide}}）</span>
        </template>
        <div class="express" v-show="answerWay == 2">
          <div class="question-info" v-show="loadedExpress === 1" v-if="question.answer_way == 2">
            <template v-if="question.subject.length > 0">
              <img class="question-img" ref="expressPic" @load="loadExpressPic" :src="question.subject" alt="">
            </template>
            <template v-else>
              <h1 style="padding-bottom: 10vh;white-space: nowrap">{{ question.title }}</h1>
            </template>
          </div>
          <div class="show-loading" v-show="loadedExpress === 0" :style="{width:expressWidth+'px'}">
            <div class="loader">
              <div class="pacman">
                <div class="mouth"></div>
              </div>
              <div class="dot"></div>
            </div>
          </div>
        </div>
        <div class="option-btns" ref="optionBtnRef"
             v-if="(question.question_type === 2) || (question.question_type === 1 && !showAgain) || repeatAnswerCount > 0">
          <div class="default-btn next-btn" @click="nextQuestion()" v-if="question.exam_type === 1">
            <span>下一题</span>
          </div>
        </div>
        <div class="option-btns" v-if="question.question_type === 1 && showAgain && repeatAnswerCount === 0"
             style="justify-content:center">
          <div class="default-btn next-btn redo-btn" @click="clearResult(true)" v-if="question.exam_type === 1">
            <span>重做一次</span>
          </div>
        </div>
        <div class="question-steers" ref="questionSteersRef" :style="{width: '100%',alignItems:'center',marginTop:0}">
          <template v-show="steers.length > 0">
            <div class="steers-container">
              <div class="steer-items" @click="playSteerVoice(item.path)" v-for="(item,index) in steers" :key="index">{{ item.title }}</div>
            </div>
          </template>
          <div class="steers-tip" v-if="question.steers_tip && question.steers_tip.length > 0">
            ※{{question.steers_tip}}
          </div>
        </div>
        <div class="tips" ref="tipsRef" v-show="questionType === 1 && question.show_mark === 1">
          ※若儿童回答错误，施测者可以示范正确答案并说明为什么，并再练习一次（限再练习一次）。
        </div>
      </div>
    </template>
    <audio id="audio" ref="audio" :src="voiceUrl" @ended="voiceFinish"></audio>
    <audio ref="steerTip" src="" @ended="initTimer"></audio>
    <div class="connect" v-if="!connect">当前服务端连接失败，将无法进行表达量表的施测。</div>
    <div :class="joinNewUser ? 'join-user-show' : 'join-user-hide'">测评师已加入</div>
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav'
import WebSocketClient from '@/libs/websocket-client'
import QrCode from 'qrcode.vue'
import GLOBAL from '../config/config'

const querySelector = document.querySelector('.revt-page')
export default {
  name: 'revt',
  data () {
    return {
      ctx: null,
      img: null,
      canvasWidth: null,
      expressWidth: null,
      scale: 1,
      offsetX: 0,
      offsetY: 0,
      selections: [],
      coordinate: [],
      checking: false,
      current: 'evaluation',
      steers: [],
      questionType: 1,
      examType: 1,
      answerWay: 1,
      question: {},
      candidateAnswer: [],
      checkList: [],
      loading: null,
      welcome: require('../assets/voice/welcome.aac'),
      voiceUrl: '',
      underVoice: [
        require('../assets/voice/under_tip_01_nomal.aac'),
        require('../assets/voice/under_tip_02.mp3'),
      ],
      expVoice: [
        require('../assets/voice/exp_tip_01_normal.aac'),
        require('../assets/voice/exp_tip_02.aac'),
      ],
      tipsVoice: [
        require('../assets/voice/under_05_sec.aac'),
        require('../assets/voice/exp_05_sec.aac')
      ],
      step: 0,
      stepContent: [
        [
          '不宜立即进入测验情境，需先与儿童建立良好关系。',
          '在图片上按一次会标记出答案，相同位置再按一次则会移除该答案。',
          '得分2分的题目，系统会追问一次“还有吗？再指出来。”；<br>得分3分的题目，系统会追问两次。',
          '若题目念完，20秒后儿童无反应，系统会再念一次题目并请儿童回答。重述题目以一次为限。',
          '如果儿童回答不出来，施测者可以按下右侧的“下一题”直接进入下一题。',
          '若儿童指认的答案数量超过原本的目标答案，施测者可以再强调一次题目，并以最后一次的反应顺序为答案依据。',
          '本评量为语音指导，请点选音量测试；并将电脑音量调整为合适的大小。'
        ],
        [
          '请同步使用另一台手机/平板或是计算机登入后台，同步记录儿童作答结果。',
          '如果回答出正确答案，请点选答案前方的圆圈。如果回答不正确或回答不出来，可以按下右侧“下一题”直接进入下一题。',
          '得分2分的题目，系统最多追问一次“还有吗？再说说看。”<br>得分3分的题目，系统最多追问两次。<br>得分4分的题目，系统最多追问三次。',
          '后台的答案有【追】字者，代表接近正确答案，但还不是正确答案，须请儿童加以澄清，施测者可以追问一次，但以一次为限，若仍回答错误，则按“下一题”进入下一题。',
          '题目有【引导】两字者，施测者可依引导内容，对儿童作适当引导，但引导内容须依题目指示，不宜过度引导。标示【不引导】者，则不提供任何线索，但可依照提醒3的标准追问。',
          '题目会随着受试者程度跳题作答，计分时请确认题号再给分。'
        ]
      ],
      uid: '',
      wsClient: null,
      needAuth: true, // 需要重新认证的标记
      connect: true,
      userClient: '',
      codeSize: 100,
      joinNewUser: false,
      showStagePage: true,
      showJoinCard: false,
      chooseAnswer: [],
      timer: null,
      waitSeconds: 0,
      drawCorrect: [],
      isTipVoice: false,
      showAgain: false,
      repeatAnswerCount: 0,
      title_id: this.$route.query.eid,
      exam_id: this.$route.query.exam_id,
      invalid: false,
      baseWidth: 1920,
      loadingWidth: 0,
      loadingHeight: 0,
      loadedCanvas: false,
      loadedExpress: 0,
      selfClick: false,
      questionPlaying: false,
      correctPoints:[],
      questionTitleTimer:true,
      voiceTipTimer:null,
      screenPageWidth:0,
      screenPageHeight:0,
      canvasLoadedHeight:0,
      canvasLoadedWidth:0
    }
  },
  mounted () {
    this.screenPageWidth = document.documentElement.clientWidth
    this.screenPageHeight = document.documentElement.clientHeight - 84
    this.resizeScale()
    window.addEventListener('keydown', this.spaceKeyDownHandler)
    window.addEventListener('resize', this.resizeScale)
    this.initExam()
  },
  created () {
    // 生成唯一ID作为分组--正常来讲在这个是填写基本信息后生成
    // this.uid = this.getGuid()
  },
  methods: {
    resizeScale () {
      this.screenPageWidth = document.documentElement.clientWidth
      this.screenPageHeight = document.documentElement.clientHeight - 84
      let screenWidth = document.documentElement.clientWidth
      let scale = screenWidth / this.baseWidth
      let page = document.querySelector('.revt-page')
      page.style.setProperty('--scale', scale)
      page.style.setProperty('--content-height','calc(100vh - 90px)')
      this.codeSize = 100 * scale
      if (this.question.exam_type === 1 && [2].indexOf(this.step) > -1 && !this.showStagePage) {
        // 用于监听屏幕大小变动进行canvas重新绘制，避免无法正常点击答题
        this.clearPageTimeInterval()
        clearInterval(this.voiceTipTimer)
        this.checkList = []
        this.selections = []
        this.drawCorrect = []
        this.coordinate = []
        this.init(this.question.subject)
      }
    },
    // 初始化websocket连接
    initWebSocket () {
      this.wsClient = new WebSocketClient(GLOBAL.WEBSOCKETIP, {
        reconnMaxAttempts: Infinity // 无限重试
      })
      this.wsClient
          .on('onopen', () => {
            // 连接/重连后发送必要消息
            this.connect = true
            setTimeout(res => {
              this.clientJoinGroup()
            }, 300)
          })
          .on('onreconnect', (attempts) => {

          })
          .on('onmessage', (e) => {
            // 处理业务消息
            const data = JSON.parse(e.data)
            this.handleMessage(data)
          })
          .on('onclose', (e) => {
            this.connect = false
            // console.log('连接失败', 'close')
          })
          .on('onerror', (e) => {
            this.connect = false
            // console.log('连接失败')
          })

      this.wsClient.connect()
    },
    // 客户端断线重连重新加入分组
    clientJoinGroup () {
      this.wsClient.send({
        type: 'join',
        content: {group: this.uid, user: this.uid}
      })
    },
    /**
     * 初始化canvas，加载交互图片
     * @param imgPath   需要交互的图片
     */
    init (imgPath) {
      this.underLoadDomHeight()
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      this.ctx = ctx
      this.img = new Image()
      this.img.src = imgPath // 确保路径正确
      // 加载图片
      this.img.onload = () => {
        // 加载canvas
        this.loadedCanvas = true
        this.initCanvas()
        // 监听H5画布触摸事件
        this.setupEventListeners()
      }
    },
    initExam () {
      this.$post('canvas/init', {exam_id: this.exam_id}).then(res => {
        if (res.code === 200) {
          let question = res.data
          this.correctPoints = question.points
          this.examType = question.exam_type
          this.answerWay = question.answer_way
          this.questionType = question.question_type
          this.question = question
          this.candidateAnswer = question.answer
          this.showStagePage = true
          this.uid = res.room
          this.steers = question.steers
          this.userClient = GLOBAL.WEB_SITE + '/#/revt_test_teacher?sign=' + res.room
          this.initWebSocket()
          switch (question.exam_type) {
            case 1: // 理解量表
              if (question.question_type === 1) {
                // 练习题
                this.step = 0
              }
              if (question.question_type === 2) {
                // 正式题
                this.step = 2
              }
              break
            case 2: // 表达量表
              this.step = 3
              this.showJoinCard = true
              break
          }
          this.init(res.data.subject)
        } else {
          this.invalid = true
          this.$layer.msg(res.msg)
        }
      })
    },
    /**
     * 获取指定题目信息
     * @param params
     */
    getQuestionInfo (params = {}) {
      let expressImgContainer = this.$refs.expressPic
      if (expressImgContainer) {
        expressImgContainer.src = ''
      }
      params.sign = this.uid
      let oldInfo = this.question
      this.isTipVoice = false
      this.$post('canvas/saveAndNext', params).then(res => {
        if (res.code === 200) {
          this.checkList = []
          this.selections = []
          this.drawCorrect = []
          if (this.ctx) {
            this.clearResult()
          }
          let question = res.data
          this.question = question
          this.questionTitleTimer = true
          this.correctPoints = question.points
          this.steers = question.steers
          // 量表阶段变更：理解->表达
          if (oldInfo.exam_type !== question.exam_type && question.exam_type === 2 && !question.jump) {
            this.showStagePage = true
            this.step = 3
            this.showJoinCard = true
          }
          if (question.exam_type === 1) {
            this.init(question.subject)
          }
          // 上一题和下一题题目类型不一致了
          if (oldInfo.question_type === 1 && question.question_type === 2 && !question.jump) {
            // 理解量表到表达量表
            this.showStagePage = true
          }
          if (question.subject.length === 0) {
            // 没有图片
            this.loadedExpress = true
          } else {
            let expressImgContainer = this.$refs.expressPic
            if (expressImgContainer) {
              expressImgContainer.src = ''
            }
          }
          this.examType = question.exam_type
          this.answerWay = question.answer_way
          this.questionType = question.question_type
          this.candidateAnswer = question.answer
          // 表达量表 显示题目且没有配图，直接视为加载完毕
          if (question.exam_type === 2 && !this.showStagePage && question.subject.length === 0) {
            this.loadExpressPic(true)
          }
        }
        if (res.code === 500) {
          this.invalid = true
          this.$layer.msg(res.msg)
        }
        this.showAgain = false
        this.repeatAnswerCount = 0
      })
    },

    // 将交互图片放置在canvas画布中
    initCanvas () {
      const ctx = this.ctx
      const canvas = this.$refs.canvas
      let containerWidth, containerHeight
      // 默认实际的图片高度大于设定的canvas高度，要进行比例缩放
      let rate = this.canvasLoadedHeight / this.img.height

      if (this.img.height <= this.canvasLoadedHeight){
        // 实际图片高度小于或等于设定的canvas的高度，canvas的高度就等于图片高度，计算宽度缩放
        rate = 0.9
        this.canvasLoadedHeight = this.img.height * 0.9
      }
      if((this.img.width * rate) > 0 && (this.img.width * rate) >= this.canvasLoadedWidth){
          // 缩放后的图片宽度还是大于容器宽度，使用宽度来处理
          rate = this.canvasLoadedWidth / this.img.width
      }
      
      containerWidth = this.img.width * rate
      containerHeight = this.canvasLoadedHeight
      this.canvasWidth = containerWidth

      const scaleX = containerWidth / this.img.width
      const scaleY = containerHeight / this.img.height
      this.scale = Math.min(scaleX, scaleY)
      canvas.width = this.img.width * this.scale
      canvas.height = this.img.height * this.scale

      this.loadingWidth = canvas.width
      this.loadingHeight = canvas.height
      const canvasInfo = {
        canvasHeight:this.canvasLoadedHeight,
        canvasWidth: this.canvasLoadedWidth,
        imgWidth: this.img.width,
        imgHeight: this.img.height,
        screenWidth: this.screenPageWidth,
        screenHeight: this.screenPageHeight,
        rate:rate,
        scale:this.scale,
        cw: canvas.width,
        ch: canvas.height
      }
      console.log(canvasInfo)
      // 把交互题目图片绘制到canvas画布
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(this.img, this.offsetX, this.offsetY, this.img.width * this.scale, this.img.height * this.scale)

      if (!this.showStagePage) {
        this.playVoice(this.question.title_voice_path,'initCanvas')
      }
    },

    // 坐标转换
    toOriginalCoords (canvasX, canvasY) {
      return {
        x: Math.round((canvasX - this.offsetX) / this.scale),
        y: Math.round((canvasY - this.offsetY) / this.scale)
      }
    },

    // 事件监听
    setupEventListeners () {
      const canvas = this.$refs.canvas
      // 触摸开始事件
      canvas.addEventListener('click', (e) => {
        // 上次请求未结束不进行下次处理
        if (this.checking) {
          return false
        }
        this.checking = true
        e.preventDefault() // 阻止默认行为（如页面滚动）
        const rect = canvas.getBoundingClientRect()
        const x = e.clientX - rect.left
        const y = e.clientY - rect.top
        const original = this.toOriginalCoords(x, y)
        // 检测这个区域是不是已经被选择了，已经选择过就不继续判断
        // 通过交互点击的坐标去后台获取区域结果
        // 练习题情况下，第一次回答错误并提交，禁止取消操作，要点击重做一次清空
        if (this.showAgain && this.repeatAnswerCount === 0){
          this.checking = false
          return false
        }
        this.check(original.x, original.y)
      })
    },
    /**
     * 检测点击的坐标结果
     * @param x 点击位置X轴坐标
     * @param y 点击位置Y轴坐标
     */
    check (startX, startY) {
      const correctAmount = this.question.correct_amount
      const chooseInfoLength = this.selections.length
      const question = this.question
      this.$post('canvas/checkChoose', {x: startX, y: startY, ques_id: this.question.id}).then(res => {
        this.checking = false
        const data = res.data
        const hasChooseIndex = this.coordinate.indexOf(data.id)
        switch (res.code) {
          case 200:
            if (hasChooseIndex < 0) {
              this.chooseBeginTimer()
              if (correctAmount <= chooseInfoLength) {
                // 点选的是未选择的区域，但是当前选择的答案数量已经等于正确数量
                this.checking = false
                return false
              }
              if (data.is_correct === 1) {
                this.drawCorrect.push({x: startX, y: startY, is_correct: data.is_correct})
              }
              this.selections.push({id:data.id,x: startX, y: startY, is_correct: data.is_correct, score: data.score})
              this.coordinate.push(data.id)
              this.wrongAnswerShowAgainBtn(data)
            } else {
              this.selections.splice(hasChooseIndex, 1)
              this.coordinate.splice(hasChooseIndex, 1)
              // 如果答案总数大于1个，要看一下是否需要5秒提示
              if (question.correct_amount > 1 && this.selections.length < question.correct_amount) {
                if (this.selections.length === 0){
                  // 实际没有选择，清空还有吗的语音提示
                  clearInterval(this.voiceTipTimer)
                }else {
                  this.chooseBeginTimer()
                }
              } else {
                clearInterval(this.voiceTipTimer)
              }
            }
            if (this.question.question_type === 2) {
              // 正式题
              this.drawResult()
            } else {
              // 练习题
              this.drawPractice()
            }
            break
          case 300:
            this.$layer.msg(res.msg)
            break
          case 500:

            break
        }
      })
    },
    /**
     * 绘制已经点选的区域
     */
    drawResult () {
      const ctx = this.ctx
      const canvas = this.$refs.canvas
      // 先清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(this.img, this.offsetX, this.offsetY, this.img.width * this.scale, this.img.height * this.scale)
      // 获取已选择的坐标并以此为中心进行画圈
      const selections = this.selections
      selections.forEach((item) => {
        ctx.beginPath()//开始绘制
        ctx.arc(item.x * this.scale, item.y * this.scale, 50 * this.scale, 0, 2 * Math.PI)//arc 的意思是“弧”
        ctx.strokeStyle = '#ffdc00' //开始填充
        ctx.lineWidth = 4
        ctx.stroke()
      })
    },
    /**
     * 绘制练习题回答结果
     */
    drawPractice(resetData = []){
      const ctx = this.ctx
      const canvas = this.$refs.canvas
      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      // 重新绘制图片
      ctx.drawImage(this.img, this.offsetX, this.offsetY, this.img.width * this.scale, this.img.height * this.scale)
      const selections = resetData.length === 0 ? this.selections : resetData
      selections.forEach((item) => {
        if (item.is_correct === 1) {
          this.drawCheckmark(ctx,item.x,item.y)
        } else {
          this.drawCross(ctx,item.x,item.y)
        }
      })
    },

    /**
     * 绘制错误标志
     * @param x
     * @param y
     * @param size
     */
    drawCross (ctx,x, y,size = 40) {
      // 计算斜线端点
      const offset = size / 2
      const topLeftX = x * this.scale - offset
      const topLeftY = y * this.scale - offset
      const bottomRightX = x * this.scale + offset
      const bottomRightY = y * this.scale + offset
      const topRightX = x * this.scale + offset
      const topRightY = y * this.scale - offset
      const bottomLeftX = x * this.scale - offset
      const bottomLeftY = y * this.scale + offset
      ctx.beginPath()
      // 绘制两条交叉线
      ctx.moveTo(topLeftX, topLeftY)
      ctx.lineTo(bottomRightX, bottomRightY)
      ctx.moveTo(topRightX, topRightY)
      ctx.lineTo(bottomLeftX, bottomLeftY)
      // 设置样式
      ctx.strokeStyle = '#F44336' // 红色
      ctx.lineWidth = size / 5
      ctx.lineCap = 'round'
      ctx.stroke()
      ctx.restore()
    },
    /**
     * 绘制正确标志
     * @param x
     * @param y
     * @param size
     */
    drawCheckmark (ctx,x, y,size = 40) {
      // 计算路径点
      const startX = x * this.scale - size / 2
      const startY = y * this.scale + size / 4
      const midX = x * this.scale - size / 8
      const midY = y * this.scale + size / 2
      const endX = x * this.scale + size / 2
      const endY = y * this.scale - size / 2
      ctx.beginPath()
      // 绘制路径
      ctx.moveTo(startX, startY)
      ctx.lineTo(midX, midY)
      ctx.lineTo(endX, endY)
      // 设置样式
      ctx.strokeStyle = '#4CAF50' // 绿色
      ctx.lineWidth = size / 5
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
      ctx.stroke()
      ctx.restore()
    },
    /**
     * 清空答题信息清空canvas画布
     * @param playVoice 是否重播题目语音
     */
    clearResult (playVoice = false) {
      const ctx = this.ctx
      const canvas = this.$refs.canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(this.img, this.offsetX, this.offsetY, this.img.width * this.scale, this.img.height * this.scale)
      this.selections = []
      this.coordinate = []
      this.checkList = []
      this.repeatAnswerCount++
      // 是重做一次的操作并且需要重播题目语音
      if (this.showAgain && playVoice) {
        // 再做一次按钮
        this.clearPageTimeInterval()
        this.playVoice(this.question.title_voice_path,'clearResult')
      }
    },
    // 获取下一题
    nextQuestion (jump = false) {
      // 停止播放
      this.$refs.audio.pause()
      this.$refs.audio.removeAttribute('src')
      this.$refs.audio.load()
      this.clearPageTimeInterval()
      clearInterval(this.voiceTipTimer)
      // 点击下一题要对练习题进行判断，如果是多个正确答案，但是没有选择完，就要把剩余未选择的正确答案标记错误
      // 正式题点击下一题不需要进行未选择答案的提示，直接进入
      const repeatAnswerCount = this.repeatAnswerCount
      if (this.question.question_type === 1 && repeatAnswerCount === 0){
        let notSelected = []
        // 已经选择的坐标通过接口获取到的配置ID
        let coordinate = this.coordinate
        // 当前题目的所有答案
        let correctPoints = this.correctPoints
        // 当前已选择的答案信息(已经验证过对错)
        let selections = JSON.parse(JSON.stringify(this.selections))
        for (let i = 0; i < correctPoints.length; i++) {
          let correctInfo = correctPoints[i]
          if (coordinate.indexOf(correctInfo['id']) < 0) {
            notSelected.push(correctInfo)
          }
        }

        if(notSelected.length > 0){
          let resetData = selections.concat(notSelected)
          this.drawPractice(resetData)
          // 清除5秒提示定时器
          clearInterval(this.voiceTipTimer)
          // 显示重做一次，
          this.showAgain = true
          return false
        }
      }

      if (this.invalid) {
        this.$layer.msg('当前施测信息不存在，请稍后再试。')
        return false
      }
      let chooseAnswer = []
      if (this.answerWay === 1) {
        // 图片交互
        chooseAnswer = this.selections
      }
      if (this.answerWay === 2) {
        // 双屏
        chooseAnswer = this.checkList
      }
      this.chooseAnswer = chooseAnswer
      let params = {
        exam_id: this.exam_id,
        level: this.question.level,
        number: this.question.number,
        ques_id: this.question.id,
        question_type: this.question.question_type,
        answer: this.chooseAnswer,
        sort: this.question.sort
      }

      this.loadedCanvas = false
      this.loadedExpress = 0
      this.selfClick = true
      this.getQuestionInfo(params)

    },
    // 处理websocket接收到的消息
    handleMessage (data) {
      switch (data.type) {
        case 'news':
          if (this.selfClick) {
            this.selfClick = false
            return false
          }else{
            let question = data.content.question
            if (question.exam_type === 2) {
              this.loadedExpress = 0
            }
            let expressImgContainer = this.$refs.expressPic
            if (expressImgContainer) {
              expressImgContainer.src = ''
            }
            let oldInfo = this.question
            if (this.loading) {
              this.loading.close()
            }
            this.$refs.audio.pause()
            this.clearPageTimeInterval()
            clearInterval(this.voiceTipTimer)
            this.isTipVoice = false
            this.checkList = []
            this.answerWay = question.answer_way
            this.questionType = question.question_type
            this.examType = question.exam_type
            this.question = question
            this.steers = question.steers
            // 量表阶段变更：理解->表达
            if (oldInfo.exam_type !== question.exam_type && question.exam_type === 2 && !question.jump) {
              this.showStagePage = true
              this.step = 3
              this.showJoinCard = true
            }
            if (oldInfo.question_type === 1 && question.question_type === 2 && !question.jump) {
              // 理解量表到表达量表
              this.showStagePage = true
            }

            if (question.subject.length === 0) {
              // 没有图片
              this.loadedCanvas = true
              this.loadedExpress = 1
              this.playVoice(question.title_voice_path)
            }
            if (this.question.exam_type === 2){
              this.expressLoadDomHeight()
            }
          }
          break
        case 'loading':
          // 加载新题目中
          // this.loading = this.$loading({
          //   lock: true,
          //   text: '题目加载中',
          //   spinner: 'el-icon-loading',
          //   background: 'rgba(0, 0, 0, 0.4)'
          // })
          break
        case 'error':

          break
        case 'finish':
        case 'invalid':
          clearInterval(this.voiceTipTimer)
          clearInterval(this.timer)
          this.$confirm('当前用户施测已结束。', '', {
            showClose: false,
            closeOnClickModal: false,
            center: true,
            distinguishCancelAndClose: true,
            confirmButtonText: '前往我的测评',
            cancelButtonText: '返回首页',
            confirmButtonClass: 'confirm-submit',
            cancelButtonClass: 'cancel-submit'
          }).then(res => {
            this.$router.push('/InventoryList')
          }).catch(err => {
            this.$router.push('/index')
          })

          break
        case 'join success':
          if (data.content.user !== this.uid) {
            this.joinNewUser = true
            setTimeout(() => {
              this.joinNewUser = false
            }, 3000)
          }
          break
        case 'next':
          this.step = data.content.step
          if (data.content.step === 4) {
            // 播放指导语
            this.showStagePage = false
            this.playVoice(this.expVoice[1])
          }
          if (data.content.step === 5 || data.content.step === 6) {
            this.showStagePage = false
            this.loadExpressPic()
            this.expressLoadDomHeight()
            this.playVoice(this.question.title_voice_path)
          }
          break
        case 'choose':
          this.checkList = JSON.parse(data.content.answer)
          this.chooseBeginTimer()
          break
        case 'play':
          this.playSteerVoice(data.content.url)
          break
      }
    },
    // 推送消息到服务端
    sendMessage (data = {type: 'chat', content: 'Hello World'}) {
      if (this.question.exam_type === 2 || data.type === 'join') {
        const success = this.wsClient.send(data)
        if (!success) {
          this.$message.error('发送失败，连接已断开')
        }
      }
    },
    /**
     * 监听空格事件
     * @param event
     */
    spaceKeyDownHandler (event) {
      if (this.invalid) {
        this.$layer.msg('当前施测信息不存在，请稍后再试。')
        return false
      }
      let step = this.step
      // 练习题阶段
      if (event.keyCode == 32 && [0, 3].indexOf(step) > -1) {
        this.setQuestionStagePage()
      }
      // 练习题转正式题阶段
      if (event.keyCode == 32 && [2, 5].indexOf(step) > -1 && this.showStagePage) {
        this.setQuestionStagePage()
      }
    },
    // 展示题目信息
    showQuestion () {
      if (this.invalid) {
        this.$layer.msg('当前施测信息不存在，请稍后再试。')
        return false
      }
      this.loadExpressPic()
      this.setQuestionStagePage()
    },
    setQuestionStagePage () {
      let step = this.step
      switch (step) {
        case 0:
          // 显示理解量表阶段、施测前提醒
          this.step = this.showStagePage ? 0 : 1
          this.showStagePage = this.showStagePage === true ? false : false
          if (this.step == 0 && !this.showStagePage) {
            // 播放施测前提醒音频
            this.playVoice(this.underVoice[0])
          }
          if (this.step == 1 && !this.showStagePage) {
            // 播放施测前提醒音频
            this.playVoice(this.underVoice[1])
          }
          break
        case 1:
          // 理解量表引导语
          this.step++
          // 播放题目音频
          this.playVoice(this.question.title_voice_path,'setQuestionStagePage--1')
          this.init(this.question.subject)
          break
        case 2:
          // 理解量表正式题
          this.showStagePage = this.showStagePage === true ? false : false
          // canvas图片渲染完成，播放语音，否则不播放，等加载结束自动播放
          if(this.loadedCanvas){
            this.playVoice(this.question.title_voice_path,'setQuestionStagePage--2')
          }
          this.init(this.question.subject)
          break
        case 3:
          // 显示表达量表阶段、施测前提醒
          if (this.showStagePage) {
            this.step = 3
            this.showJoinCard = true
            this.showStagePage = this.showStagePage === true ? false : false
            // 播放施测前提醒音频
            this.playVoice(this.expVoice[0])
          } else {
            // 检测施测端是否加入
            this.checkClientJoin((res) => {
              if (res) {
                this.step = 4
                this.showStagePage = false
                // 播放施测前提醒音频
                this.playVoice(this.expVoice[1])
                this.updateClientState('next', 4)
                this.updateClientState()
              }
            })
          }
          break
        case 4:
          // 表达量表引导语，要通知测试端显示题目
          this.step++
          this.playVoice(this.question.title_voice_path,'setQuestionStagePage--4')
          this.updateClientState('next', 5)
          this.expressLoadDomHeight()
          this.loadExpressPic()
          break
        case 5:
          // 表达量表正式题
          this.showStagePage = this.showStagePage === true ? false : false
          // 题目展示页面并且图片加载完成，播放语音
          if (!this.showStagePage && this.loadedExpress === 1) {
            this.playVoice(this.question.title_voice_path,'setQuestionStagePage--5')
          }
          this.updateClientState('next', 6)
          this.expressLoadDomHeight()
          // 要通知客户端显示题目
          break
      }
    },
    expressLoadDomHeight(){
      this.$nextTick(() => {
        let page = document.querySelector('.revt-page')
        page.style.setProperty('--question-title-height', Math.ceil(this.$refs.questionTitleRef.offsetHeight) + 1 + 'px')
        page.style.setProperty('--question-steers-height', Math.ceil(this.$refs.questionSteersRef.offsetHeight) + 1 + 'px')
        page.style.setProperty('--tip-height', this.$refs.tipsRef.offsetHeight + 'px')
        if (this.question.action_guide && this.question.action_guide.length > 0){
          page.style.setProperty('--action-guide-height', isNaN(this.$refs.actionGuideRef.offsetHeight) ? 0 : (Math.ceil(this.$refs.actionGuideRef.offsetHeight) + 'px'))
        } else {
          page.style.setProperty('--action-guide-height', '0px')
        }
      })
    },
    underLoadDomHeight(){
      this.$nextTick(() => {
        let page = document.querySelector('.revt-page')
        const titleHeight = Math.ceil(this.$refs.questionTitleRef.offsetHeight)
        const steerHeight = Math.ceil(this.$refs.questionSteersRef.offsetHeight)
        const tipHeight = Math.ceil(this.$refs.tipsRef.offsetHeight)
        const containerHeight = Math.ceil(this.$refs.questionContianerRef.offsetHeight)
        const containerWidth = Math.ceil(this.$refs.questionContianerRef.offsetWidth)
        const btnHeight = Math.ceil(this.$refs.optionBtnRef.offsetHeight)
        page.style.setProperty('--question-title-height', titleHeight + 'px')
        page.style.setProperty('--question-steers-height', steerHeight + 1 + 'px')
        page.style.setProperty('--tip-height', tipHeight + 'px')
        page.style.setProperty('--container-height', containerHeight + 'px')
        page.style.setProperty('--next-question-btn-height', btnHeight + 'px')
        const canvasHeight = containerHeight - titleHeight - steerHeight - tipHeight - btnHeight
        // 减去32是canvas父级容器的上下内边距
        this.canvasLoadedHeight = canvasHeight - 32
        this.canvasLoadedWidth = containerWidth
      })
    },

    getString () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    getGuid () {
      return (this.getString() + this.getString() + '-' + this.getString() + '-' + this.getString() + '-' + this.getString() + this.getString() + this.getString() + this.getString())
    },
    copyUserUrl () {
      let oInput = document.createElement('input')
      oInput.value = this.userClient
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$layer.msg('受试连接已复制，请在分屏浏览器中打开。')
      oInput.remove()
    },
    checkClientJoin (callback) {
      this.$post('canvas/checkClient', {sign: this.uid}).then(res => {
        if (res.code == 200 && res.data == 2) {
          callback(true)
        } else {
          this.$layer.msg(res.msg)
          callback(false)
        }
      })
    },
    updateClientState (type = 'stage', step = false) {
      this.sendMessage({
        type: type,
        content: {
          group: this.uid,
          step: !step ? this.step : step,
          stage: this.showStagePage
        }
      })
    },
    async playVoice (url,type=0) {
      // console.log(type,'播放音频了')
      // 先停止正在播放的内容
      this.$refs.steerTip.pause()
      this.$refs.audio.pause()
      // 移除
      this.$refs.audio.removeAttribute('src')
      this.$refs.audio.load()
      // 设置新源并等待加载
      this.$refs.audio.src = url
      await new Promise(resolve => {
        this.$refs.audio.addEventListener('loadedmetadata', resolve)
      })

      // 执行播放
      const playPromise = this.$refs.audio.play()
      // 处理可能的中断
      if (playPromise !== undefined) {
        playPromise
            .then(() => {
              this.questionPlaying = true
              this.pauseTheTimer();
            })
            .catch(err => {
              // 这里可以显示播放按钮让用户手动触发
            })
      }
    },
    voiceFinish () {
      let step = this.step
      this.questionPlaying = false
      if ([2, 5, 6].indexOf(step) > -1 && !this.showStagePage && !this.timer && !this.isTipVoice && this.questionTitleTimer) {
        this.initTimer()
      }
    },
    /**
     * 每次开始回答问题就开始一个新计时器
     * 5秒后根据不同内容做出逻辑
     */
    chooseBeginTimer(){
      clearInterval(this.voiceTipTimer)
      let number = 0;
      this.voiceTipTimer = setInterval(()=>{
        number++
        const question = this.question
        const chooseData = question.exam_type === 1 ? this.selections : this.checkList
        const correct = question.exam_type === 1 ? question.correct_amount : question.answer.length
        if (number === 5 && chooseData.length < correct) {
          // 距离上次回答过了5秒，还存在没有选择的答案
          if (question.exam_type === 1){
            // 理解量表
            this.playVoice(this.tipsVoice[0])
          }
          if (question.exam_type === 2) {
            if (chooseData.length === 0){
              // 还没有选择答案、先不播放了，万一又错😭
              // this.playVoice(this.tipsVoice[1])
            }else {
              // 正确答案超过4个的，选择4个即可，语音提示也只播放3次
              if (question.number === 28) {
                // 表达量表 第28题有5个答案。只要选择4个，所以只需要播放三次语音
                if (chooseData.length < 4) {
                  this.playVoice(this.tipsVoice[1])
                }
              } else if (question.number === 54 || question.number === 63) {
                // 表达量表，第54题有6个答案。只要选择3个，所以只需要播放两次语音
                // 表达量表，第63题有4个答案。只要选择3个，所以只需要播放两次语音
                if (chooseData.length < 3) {
                  this.playVoice(this.tipsVoice[1])
                }
              } else if (question.number === 56 || question.number === 57) {
                // 表达量表，第56、57题有3个答案。只要选择2个，所以只需要播放两次语音
                if (chooseData.length < 2) {
                  this.playVoice(this.tipsVoice[1])
                }
              } else {
                if (question.steers.length === 0) {
                  // 表达量表，没有语音指导的播放还有吗 再说说看
                  this.playVoice(this.tipsVoice[1])
                } else {
                  // 有不引导的提示，且没有语音引导，播放提示语音‘还有吗，再说说看’
                  let playTip = false
                  question.steers.forEach(s => {
                    if (s.path.length === 0) {
                      playTip = true
                    }
                  })
                  if (playTip) {
                    this.playVoice(this.tipsVoice[1])
                  }
                }
              }
            }
          }
          clearInterval(this.voiceTipTimer)
        }
        if (chooseData.length === correct){
          clearInterval(this.voiceTipTimer)
        }
      },1000)
    },
    /**
     * 音量调试
     */
    voiceVolume () {
      this.playVoice(this.welcome)
    },
    loadExpressPic (play = true) {
      this.loadedExpress = 1
      if (this.question.exam_type === 2){
        this.questionTitleTimer = true
      }
      if (!this.showStagePage && (this.step === 5 || this.step === 6) && this.question.subject.length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.expressWidth = this.$refs.expressPic.width
            if (play) {
              this.playVoice(this.question.title_voice_path,'loadExpressPic-1')
            }
          }, 100)
        })
      }
      if (!this.showStagePage && (this.step === 5 || this.step === 6) && this.question.subject.length === 0) {
        // 题目没有图片，直接播放语音
        this.playVoice(this.question.title_voice_path,'loadExpressPic-2')
      }
    },
    initTimer () {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        let question = this.question
        let cate = question.exam_type
        let type = question.question_type
        let chooseData = question.exam_type === 1 ? this.selections : this.checkList
        let num = question.number
        this.waitSeconds++
        // 超过20秒不重复题目的题号-表达量表
        let ignoreNums = [32,40,58,61]
        switch (this.waitSeconds) {
          case 10:
            break
          case 20:
            // 20秒新逻辑：表达量表练习题和指定题目20秒未回答，不再重复播放题目，让老师来引导
            // 如果未回答正确，正常进行答案提示，播放“还有吗？再说说看。”
            if (chooseData.length === 0) {
              if ((cate === 2 && type === 1) || (cate === 2 && ignoreNums.indexOf(num) > -1)) {

              } else {
                this.isTipVoice = true
                this.playVoice(question.title_voice_path)
              }
            }
            break
          case 30:
            break
          case 40:
            // 40秒，无交互，直接进入下一题，清除计时器
            if (chooseData.length === 0 && !this.invalid) {
              // 没有交互，直接进入下一题
              // this.nextQuestion(true)
            }
            this.clearPageTimeInterval()
            break
        }
      }, 1000)
    },
    clearPageTimeInterval () {
      this.questionTitleTimer = false   // 超过40秒，题目重复的计时器不需要了
      this.waitSeconds = 0
      clearInterval(this.timer)
      this.timer = null
    },
    /**
     * 停止计时
     * 题目语音在播放期间，清空计时器，但是等待时间不清空0.
     */
    pauseTheTimer(){
      clearInterval(this.timer)
      this.timer = null
      this.isTipVoice = false
    },
    async playSteerVoice(path = ''){
      if (this.questionPlaying){
        this.$layer.msg('请等待题目语音播放完毕。')
        return false
      }
      if (path === null || path === '') {
        return false
      }
      let url = GLOBAL.WEB_SITE + path
      // 如果题目在播放中，停止。
      this.$refs.audio.pause()
      this.$refs.steerTip.pause()
      // 移除
      this.$refs.steerTip.removeAttribute('src')
      this.$refs.steerTip.load()
      // 设置新源并等待加载
      this.$refs.steerTip.src = url
      await new Promise(resolve => {
        this.$refs.steerTip.addEventListener('loadedmetadata', resolve)
      })

      // 执行播放
      const playPromise = this.$refs.steerTip.play()
      // 处理可能的中断
      if (playPromise !== undefined) {
        playPromise
            .then(() => {
              // 播放引导的时候停止定时器，避免占用倒计时时间
              this.pauseTheTimer();
            })
            .catch(err => {
              // 这里可以显示播放按钮让用户手动触发
            })
      }
    },
    /**
     * 答错练习题后显示重做按钮
     */
    wrongAnswerShowAgainBtn(answer){
      const question = JSON.parse(JSON.stringify(this.question))

      // 理解量表练习题点错误答案后，要直接显示重做按钮的题号
      const showUnderSingleQuestionNum = [1,2,3,6,7,8,9]    // 单选题题号
      const showUnderMultiQuestionNum = [4,5]     // 多选题题号
      if (question.exam_type === 1 && question.question_type === 1){
        // 单选题答错
        if (question.correct_amount === 1 && answer.is_correct !== 1 && showUnderSingleQuestionNum.indexOf(question.number) > -1){
          this.showAgain = true
        }
        if (question.correct_amount > 1 && showUnderMultiQuestionNum.indexOf(question.number) > -1){
          const selections = JSON.parse(JSON.stringify(this.selections))
          selections.forEach(selection => {
            if(selection.is_correct !== 1 && selections.length === question.correct_amount){
              this.showAgain = true
              return false
            }
          })
        }
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.spaceKeyDownHandler)
    window.removeEventListener('resize', this.resizeScale)
    if (this.wsClient) {
      this.wsClient.close()
    }
    // 清除所有定时器
    clearInterval(this.voiceTipTimer)
    this.clearPageTimeInterval()
  },
  components: {
    HeaderNav,
    // WebSocketClient,
    QrCode
  }
}
</script>
<style>
:root {
  --question-title-height: 0; /* 默认值，会被 JS 覆盖 */
  --question-steers-height:0;
  --action-guide-height:0;
  --tip-height:0;
}
.express-qrcode > div > canvas {
  border: 1px solid #f39800;
  padding: calc(4px * var(--scale));
}

p > img,
span > img {
  max-height: 50vh;
  width: auto;
  height: auto;
  max-width: 50vw;
}

body {
  background-color: #ffffff !important;
  user-select: none;
}

.confirm-submit {
  background-color: #f39902 !important;
  color: #ffffff;
  border: 1px solid #f39902 !important;
}

.confirm-submit:hover {
  background-color: #f39902d1 !important;
  color: #ffffff;
  border: 1px solid #f39902d1 !important;
}

.cancel-submit:hover {
  background-color: #e6e6e6 !important;
  color: #000000;
  border: 1px solid #e6e6e6 !important;
}

/* p>img{
    width: 100%;
} */
.el-checkbox-group {
  display: flex;
  flex-direction: column;
}

.el-checkbox {
  margin: 4px 0;
}

.el-checkbox__inner {
  border-radius: 50% !important;
  width: 20px;
  height: 20px;
}

.el-checkbox__inner::after {
  height: 12px;
  left: 6px;
  width: 6px;
}

.el-checkbox__label {
  font-size: 16px;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f39902;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f39902;
  border-color: #f39902;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #f39902;
}

.el-checkbox__inner:hover {
  border-color: #f39902;
}

.el-message-box__headerbtn:hover {
  color: #f39902 !important;
}

.question-img {
  //max-height: 74vh;
  max-height: calc(96vh - 90px - var(--question-title-height) - var(--question-steers-height) - var(--action-guide-height) - var(--tip-height));
  width: auto;
  height: auto;
  max-width: 70vw;
  box-sizing: border-box;
}
</style>
<style scoped lang="less">
@import url('../assets/css/page/revt_center');
@import url('../assets/css/revt_load');
</style>